import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { Link as RouterLink, useParams, useLocation } from 'react-router-dom'
import {
  Container,
  Grid,
  InputAdornment,
  Paper,
  IconButton,
  OutlinedInput,
  InputLabel,
  FormControl,
  FormHelperText,
} from '@material-ui/core'
import { ArrowBackRounded as BackIcon } from '@material-ui/icons'
import { isArray } from '../../utils/customMethods'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import api from '../../services/api'
import Button from '../../components/atoms/inputs/button'
import Typography from '../../components/atoms/display/typography'
import CircularProgress from '../../components/atoms/feedback/circularProgress'
import Snackbar from '../../components/atoms/feedback/snackbar'
import Alert from '../../components/atoms/feedback/alert'
import SwitchLanguage from '../../components/molecules/switchs/language'
import SwitchTheme from '../../components/molecules/switchs/theme'

const PasswordReset = ({ t }) => {
  const location = useLocation();

  let { token } = useParams()
  if (!token) {
    token=location.state?.token;
  }
  const [done, setDone] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({})
  const [formError, setFormError] = useState({})
  const [snackbar, setSnackbar] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('')
  const [isVisiblePassword, setIsVisiblePassword] = useState(false)
  const [isVisibleRepeatPassword, setIsVisibleRepeatPassword] = useState(false)

  const inputHandle = (event) => {
    setForm((form) => ({
      ...form,
      [event?.target?.name]: event?.target?.value,
    }))
  }

  const passwordCheck2 = () => {
    setFormError({})
    let error = false
    let password = form.newPassword
    let passwordRepeat = form.passwordRepeat

    if (password?.length > 0 && passwordRepeat?.length > 0) {
      if (password !== passwordRepeat) {
        error = true
        setFormError((formError) => ({
          ...formError,
          passwordRepeat: 'passwordsAreNotTheSame',
        }))
      }

      if (
        !password.match(
          /^(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_]).{8,}$/
        )
      ) {
        error = true
        setFormError((formError) => ({
          ...formError,
          newPassword:
            'Password must be at least 8 characters long, contain at least one uppercase character, contain at least one number and contain at least one special character',
        }))
      }
      if (!error) {
        submit()
      }
    } else {
      password === undefined &&
        setFormError((formError) => ({
          ...formError,
          newPassword: 'password is required',
        }))
      passwordRepeat === undefined &&
        setFormError((formError) => ({
          ...formError,
          passwordRepeat: 'password is required',
        }))
    }
  }

  const submit = () => {
    setFormError({})
    setLoading(true)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    api({
      method: 'POST',
      url: '/user/password-change',
      data: {
        password: form.newPassword,
        slug: process.env.REACT_APP_SLUG,
      },
    })
      .then((response) => {
        setLoading(false)
        setDone(true)
      })
      .catch((error) => {
        setLoading(false)
        let data = error?.response?.data
        if (error?.response?.status === 401) {
          setSnackbar(true)
          return setSnackbarMessage(t('alerts.passwordNew401'))
        }
        isArray(data?.message) &&
          data.message.map((el) => {
            if (el.value === 'password must be different from the previous') {
              return setFormError((formError) => ({
                ...formError,
                newPassword: el.value,
              }))
            }
          })
      })
  }

  const renderDone = () => {
    return (
      <>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Alert severity="success" icon={false}>
            {t('alerts.passwordNewSuccess')}
          </Alert>
        </Grid>
      </>
    )
  }

  const renderForm = () => {
    return (
      <>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Alert severity="info" icon={false}>
            {t('alerts.passwordNew')}
          </Alert>
        </Grid>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <FormControl
            fullWidth
            style={{ marginTop: '5px' }}
            variant="outlined"
          >
            <InputLabel htmlFor="field-newPassword">
              {t('fields.newPassword.label')}
            </InputLabel>
            <OutlinedInput
              id="field-newPassword"
              label={t('fields.newPassword.label')}
              placeholder={t('fields.newPassword.placeHolder')}
              type={isVisiblePassword ? 'text' : 'password'}
              value={form.newPassword ? form.newPassword : ''}
              color="primary"
              variant="outlined"
              name="newPassword"
              onChange={inputHandle}
              shrink={true}
              fullWidth={true}
              error={formError?.newPassword ? true : false}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setIsVisiblePassword(!isVisiblePassword)}
                  >
                    {isVisiblePassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
            <FormHelperText
              style={{ marginBottom: '10px' }}
              error={true}
              id="standard-weight-helper-text-password"
            >
              {formError?.newPassword &&
                t(`fields.newPassword.errors.${formError.newPassword}`)}
            </FormHelperText>
          </FormControl>

          <FormControl
            fullWidth
            style={{ marginTop: '5px' }}
            variant="outlined"
          >
            <InputLabel htmlFor="field-newPassword">
              {t('fields.passwordRepeat.label')}
            </InputLabel>
            <OutlinedInput
              id="field-newPassword"
              label={t('fields.passwordRepeat.label')}
              placeholder={t('fields.passwordRepeat.placeHolder')}
              type={isVisibleRepeatPassword ? 'text' : 'password'}
              color="primary"
              variant="outlined"
              name="passwordRepeat"
              value={form.passwordRepeat ? form.passwordRepeat : ''}
              onChange={inputHandle}
              shrink={true}
              fullWidth={true}
              error={formError?.passwordRepeat ? true : false}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() =>
                      setIsVisibleRepeatPassword(!isVisibleRepeatPassword)
                    }
                  >
                    {isVisibleRepeatPassword ? (
                      <Visibility />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </InputAdornment>
              }
            />
            <FormHelperText
              style={{ marginBottom: '10px' }}
              error={true}
              id="standard-weight-helper-text-repeat-password"
            >
              {formError?.passwordRepeat &&
                t(`fields.newPassword.errors.${formError.passwordRepeat}`)}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Button
            size="large"
            variant="contained"
            color="primary"
            fullWidth={true}
            onClick={() => passwordCheck2()}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={25} color="inherit" />
            ) : (
              t('buttons.changePassword')
            )}
          </Button>
        </Grid>
      </>
    )
  }

  return (
    <>
      <Container>
        <div style={{ height: 84 }} />
        <Grid container direction="row" spacing={2} justify="center">
          <Grid item xl={4} lg={4} md={6} sm={8} xs={12}>
            <Paper elevation={12}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 120,
                  backgroundColor: '#f6f6f6',
                }}
              >
                <img src="/logo.png" alt="Porto" width="180" height="56" />
              </div>
              <div style={{ padding: 50 }}>
                <Grid container direction="row" spacing={2}>
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <Button
                      size="large"
                      color="primary"
                      startIcon={<BackIcon color="primary" />}
                      component={RouterLink}
                      to="/signin"
                    >
                      {t('buttons.back')}
                    </Button>
                  </Grid>
                  {done ? renderDone() : renderForm()}
                </Grid>
              </div>
            </Paper>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: 25,
              }}
            >
              <Typography variant="body1">
                © {new Date().getFullYear()} {t('app.copyright')}
              </Typography>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: 5,
              }}
            >
              <SwitchLanguage />
              <div style={{ width: 10 }} />
              <SwitchTheme />
            </div>
          </Grid>
        </Grid>
      </Container>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={snackbar}
        onClose={() => setSnackbar(false)}
        autoHideDuration={3000}
        message={snackbarMessage}
      />
    </>
  )
}

export default withTranslation()(PasswordReset)
